module.exports = "SELECT the_geom , the_geom_webmercator, area_km2\nFROM fsp_voronoid\nWHERE type_id = {type_id}\n"